import {ProxyCounter} from '@yandex-data-ui/cloud-components';
import {SurveySettings} from 'common/models/survey';

import {UserCounter} from './metrika';

enum Counters {
    Main = 'main',
}

const {metrikaId} = window.YC;

export const metrika = new ProxyCounter(Counters.Main);

export const userCounters: UserCounter[] = [];

function initCounter(name: Counters, id: number) {
    ProxyCounter.createCounters([
        {
            name,
            id,
        },
    ]);
}

export function initMetrika() {
    if (metrikaId) {
        initCounter(Counters.Main, metrikaId);
    }
}

export function initUserCounters(
    survey: SurveySettings,
    counterSettings: {[key: string]: boolean | {}},
) {
    if (survey.metric && userCounters.length === 0) {
        try {
            userCounters.push(
                new window.Ya.Metrika2({
                    id: survey.metric.form,
                    ...counterSettings,
                }),
            );
        } catch {}
        if (survey.metric.group) {
            try {
                userCounters.push(
                    new window.Ya.Metrika2({
                        id: survey.metric.group,
                        ...counterSettings,
                    }),
                );
            } catch {}
        }
    }
}
